import React, { useState, useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { NavLink, useLocation } from "react-router-dom";
import {
  AppBar,
  Box,
  Menu,
  MenuItem,
  Avatar,
  Tooltip,
  Typography,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Collapse,
  useMediaQuery,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { useDispatch, useSelector } from "react-redux";
import { getUserData } from "../../Redux/UserDetails";
import { BASE_API_URL } from "../../utils/constants";
import WelcomeName from "./WelcomeName";
import MyProfile from "../../Pages/MyProfile/MyProfile";
import MyPhoto from "../../Pages/ProfileImageFn";
import { IgniteAdmins } from "FunctionalComponents/IgniteTalks/IgniteAdmins";

function Header() {
  const [anchorEl, setAnchorEl] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("home");
  const { instance } = useMsal();
  const [temp, setTemp] = useState(false);
  const location = useLocation();

  const { pathname, search, hash } = useLocation();

  const dispatch = useDispatch();
  const userData = useSelector((state) => state.userDetails.userData[0]);
  const isDesktop = useMediaQuery("(min-width:1024px)");
  const open = Boolean(anchorEl);

  const [adminAnchorEl, setAdminAnchorEl] = useState(null);
  const adminMenuOpen = Boolean(adminAnchorEl);
  const [mobileAdminOpen, setMobileAdminOpen] = useState(false);

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleAdminMenuOpen = (event) => setAdminAnchorEl(event.currentTarget);
  const handleAdminMenuClose = () => setAdminAnchorEl(null);

  const activeAccount = instance.getActiveAccount();
  let loggedInEnterpriseId = "";
  if (activeAccount)
    loggedInEnterpriseId = activeAccount.idTokenClaims.enterpriseID;

  useEffect(() => {
    const tabFromPath = pathname.split("/")[1];
    if (tabFromPath) {
      setActiveTab(tabFromPath);
    }
  }, [pathname]);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, [pathname]);

  useEffect(() => {
    dispatch(getUserData(loggedInEnterpriseId));
  }, [loggedInEnterpriseId]);

  const profileImage = userData?.photo
    ? `${BASE_API_URL}/${userData?.photo}`
    : null;

  const normalizedUserId = loggedInEnterpriseId?.toLowerCase();
  const isAdmin = IgniteAdmins.includes(normalizedUserId);

  const learnersReportUsers = [
    "srikanth.narabathoju",
    "varsha.a.tyagi",
    "azeem.a.pinjari",
    "potnuru.sandeep",
  ];

  const canViewLearnersReport = learnersReportUsers.includes(normalizedUserId);

  const adminMenuItems = [
    { label: "Analytics", path: "/analytics", tab: "analytics" },
    ...(canViewLearnersReport
      ? [
          {
            label: "Learners Report",
            path: "/learnersReport",
            tab: "learnersReport",
          },
        ]
      : []),
    { label: "Data Upload", path: "/admin", tab: "learnersReport" },
    {
      label: "User Maintenance",
      path: "/userMaintenance",
      tab: "userMaintenance",
    },
    {
      label: "Learner Completion Status",
      path: "/learnersDetails",
      tab: "learnersDetails",
    },
  ];

  const navItems = [
    { label: "Home", path: "/home", tab: "home" },
    { label: "Learning Hubs", path: "/learningHubs", tab: "learningHubs" },
    { label: "Dashboard", path: "/dashboard", tab: "dashboard" },
    { label: "Ignite Talks", path: "/igniteTalks", tab: "igniteTalks" },
    { label: "Hall of Fame", path: "/hallOfFame", tab: "hallOfFame" },
    { label: "About Ignite", path: "/aboutIgnite", tab: "aboutIgnite" },
    { label: "Team", path: "/team", tab: "team" },
    { label: "FAQ", path: "/faq", tab: "faq" },
    ...(isAdmin
      ? [
          {
            label: "QRL",
            path: "/qrl",
            tab: "qrl",
          },
        ]
      : []),
    ...(isAdmin
      ? [
          {
            label: "Scoreboard",
            path: "/scoreboard",
            tab: "scoreboard",
            icon: process.env.PUBLIC_URL + "/Assets/Scoreboard/AI-icon.png",
          },
          {
            label: "Admin",
            tab: "admin",
            isDropdown: true,
            children: adminMenuItems,
          },
        ]
      : []),
  ];

  const isEmpty = (value) =>
    value === null ||
    value === undefined ||
    value === "" ||
    (Array.isArray(value) && value.length === 0);

  return (
    <>
      <AppBar
        position="sticky"
        elevation={0}
        sx={{
          top: 0,
          zIndex: 1100,
          px: isDesktop ? "3rem" : "1.5rem",
          py: isDesktop ? "1rem" : "0.5rem",
          backgroundColor: "#200226",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          width: "100%",
        }}
      >
        <Box>
          <NavLink
            to="/home"
            style={{
              textDecoration: "none",
              background: "transparent",
              border: "none",
            }}
            onClick={() => setActiveTab("home")}
          >
            <img
              src="Assets/igniteLogo.png"
              alt="logo"
              style={{ height: 30 }}
            />
          </NavLink>
        </Box>

        {isDesktop && (
          <Box sx={{ display: "flex", gap: 2, mx: "auto" }}>
            {navItems.map((item) =>
              item.isDropdown ? (
                <Box
                  key={item.tab}
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                  }}
                >
                  <Box
                    onClick={handleAdminMenuOpen}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: "2px",
                      cursor: "pointer",
                    }}
                  >
                    <Typography
                      sx={{
                        marginTop: "5px",
                        fontFamily: "Graphik",
                        fontSize: "12px",
                        color: "#FFFFFF",
                        fontWeight: item.children.some(
                          (child) => child.tab === activeTab,
                        )
                          ? 500
                          : 400,
                      }}
                    >
                      {item.label}
                    </Typography>
                    {adminMenuOpen ? (
                      <KeyboardArrowUpIcon
                        sx={{ fontSize: 16, color: "#FFFFFF" }}
                      />
                    ) : (
                      <KeyboardArrowDownIcon
                        sx={{ fontSize: 16, color: "#FFFFFF" }}
                      />
                    )}
                  </Box>

                  <Box
                    sx={{
                      mt: "2px",
                      height: "1.5px",
                      width: "60%",
                      borderRadius: "2px",
                      backgroundColor: item.children.some(
                        (child) => child.tab === activeTab,
                      )
                        ? "#FFFFFF"
                        : "transparent",
                      transition: "all 0.3s ease",
                    }}
                  />

                  <Menu
                    anchorEl={adminAnchorEl}
                    open={adminMenuOpen}
                    onClose={handleAdminMenuClose}
                    anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
                    transformOrigin={{ horizontal: "left", vertical: "top" }}
                    PaperProps={{
                      sx: {
                        backgroundColor: "#7500c0",
                        "& .MuiMenuItem-root": {
                          color: "#FFFFFF",
                        },
                        "& .MuiMenuItem-root:hover": {
                          backgroundColor: "rgba(255, 255, 255, 0.15)",
                        },
                      },
                    }}
                  >
                    {item.children.map((child) => (
                      <MenuItem
                        key={child.tab}
                        component={NavLink}
                        to={child.path}
                        onClick={() => {
                          setActiveTab(child.tab);
                          handleAdminMenuClose();
                        }}
                      >
                        {child.label}
                      </MenuItem>
                    ))}
                  </Menu>
                </Box>
              ) : (
                <Box
                  key={item.tab}
                  onClick={() => setActiveTab(item.tab)}
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    cursor: "pointer",
                  }}
                >
                  <NavLink
                    to={item.path}
                    style={{
                      textDecoration: "none",
                      background: "transparent",
                      border: "none",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: "2px",
                      }}
                    >
                      {item.icon && (
                        <Box
                          component="img"
                          src={item.icon}
                          alt={`${item.label} icon`}
                          sx={{
                            width: 18,
                            height: 18,
                            objectFit: "contain",
                          }}
                        />
                      )}

                      <Typography
                        sx={{
                          marginTop: "5px",
                          fontFamily: "Graphik",
                          fontSize: "12px",
                          color: "#FFFFFF",
                          fontWeight: activeTab === item.tab ? 500 : 400,
                        }}
                      >
                        {item.label}
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        mt: "2px",
                        height: "1.5px",
                        width: "60%",
                        borderRadius: "2px",
                        backgroundColor:
                          activeTab === item.tab ? "#FFFFFF" : "transparent",
                        transition: "all 0.3s ease",
                      }}
                    />
                  </NavLink>
                </Box>
              ),
            )}
          </Box>
        )}

        {/* RIGHT SECTION */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, ml: "auto" }}>
          <Tooltip title="Account settings">
            <MyPhoto profileImage={profileImage} handleClick={handleClick} />
          </Tooltip>
          <WelcomeName />

          {!isDesktop && (
            <IconButton
              sx={{ color: "#fff" }}
              onClick={() => setDrawerOpen(true)}
            >
              <MenuIcon />
            </IconButton>
          )}
        </Box>
        {/* PROFILE MENU */}
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          PaperProps={{
            sx: {
              width: "25em",
              maxWidth: "25em",
              borderRadius: "0px",
              mt: "2em",
              overflow: "visible",

              background: "linear-gradient(135deg, #f5f7fa 0%, #e4ebf5 100%)",
              maxHeight: "80vh",
              overflowY: "auto",
              overflowX: "hidden",
              scrollbarWidth: "thin",
              "&::-webkit-scrollbar": {
                width: "4px",
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#bbb",
                borderRadius: "4px",
              },
              "&::before": {
                content: '""',
                position: "absolute",
                top: "-8px",
                width: "16px",
                height: "16px",
                background:
                  "linear-gradient(135deg, #f5f7fa 0%, #e4ebf5 100%);",
                transform: "rotate(45deg)",
                boxShadow: "-2px -2px 6px rgba(0,0,0,0.08)",
                zIndex: 1,
              },
            },
          }}
        >
          <Box
            sx={{
              fontSize: "0.8em",
              background: "linear-gradient(135deg, #f5f7fa 0%, #e4ebf5 100%);",
            }}
          >
            <div className="myprofile-extra-box">
              <MyProfile onClose={handleClose} />
            </div>
          </Box>
        </Menu>
      </AppBar>

      {/* MOBILE DRAWER */}
      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
      >
        <Box sx={{ width: 250, p: 2 }}>
          <List>
            {navItems.map((item) =>
              item.isDropdown ? (
                <React.Fragment key={item.tab}>
                  <ListItem
                    button
                    onClick={() => setMobileAdminOpen((prev) => !prev)}
                    sx={{ color: "#200226" }}
                  >
                    <ListItemText primary={item.label} />
                    {mobileAdminOpen ? (
                      <KeyboardArrowUpIcon />
                    ) : (
                      <KeyboardArrowDownIcon />
                    )}
                  </ListItem>
                  <Collapse in={mobileAdminOpen} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      {item.children.map((child) => (
                        <ListItem
                          button
                          key={child.tab}
                          component={NavLink}
                          to={child.path}
                          onClick={() => {
                            setActiveTab(child.tab);
                            setDrawerOpen(false);
                            setMobileAdminOpen(false);
                          }}
                          sx={{ color: "#200226", pl: 4 }}
                        >
                          <ListItemText
                            primary={child.label}
                            sx={{
                              textDecoration:
                                activeTab === child.tab ? "underline" : "none",
                            }}
                          />
                        </ListItem>
                      ))}
                    </List>
                  </Collapse>
                </React.Fragment>
              ) : (
                <ListItem
                  button
                  key={item.tab}
                  component={NavLink}
                  to={item.path}
                  onClick={() => {
                    setActiveTab(item.tab);
                    setDrawerOpen(false);
                  }}
                  sx={{ color: "#200226" }}
                >
                  <ListItemText
                    primary={item.label}
                    sx={{
                      textDecoration:
                        activeTab === item.tab ? "underline" : "none",
                    }}
                  />
                </ListItem>
              ),
            )}
          </List>
        </Box>
      </Drawer>
    </>
  );
}

export default Header;
